import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-737bd93b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = { class: "DialogBody" }
const _hoisted_4 = { class: "DialogSection" }
const _hoisted_5 = { class: "DialogSection" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_7 = { class: "DialogSection" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_9 = { class: "DialogSection" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_11 = {
  class: "DialogSection",
  style: {"justify-content":"flex-start"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_13 = {
  class: "DialogSection",
  style: {"justify-content":"flex-start"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_15 = { class: "color3 F1_25em" }
const _hoisted_16 = { class: "F-Bold" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_18 = { class: "DialogSection" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_20 = { class: "DialogSection FlexColumn" }
const _hoisted_21 = { class: "CookiesDialogFooter" }
const _hoisted_22 = {
  class: "F-Bold",
  style: {"margin":"auto 1em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesDropInputObject = _resolveComponent("CookiesDropInputObject")!
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!
  const _component_CookiesNumberInput = _resolveComponent("CookiesNumberInput")!
  const _component_CookiesNormalInput = _resolveComponent("CookiesNormalInput")!
  const _component_CookiesDescriptionBox = _resolveComponent("CookiesDescriptionBox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: 'CookiesDialog_' + _ctx.DialogIndex,
      class: "CookiesDialogdBody"
    }, [
      (_ctx.Saving)
        ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.Loading.length > 0)
        ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 1 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_CookiesDropInputObject, {
              RowHeight: '3em',
              Name: _ctx.Translate('Customer'),
              CookiesInvalidInput: !(_ctx.MEMRead('D_Sales_Order_Customer') && _ctx.MEMRead('D_Sales_Order_Customer') !== ''),
              ErrorData: _ctx.ErrorsVisibilty && !(_ctx.MEMRead('D_Sales_Order_Customer') && _ctx.MEMRead('D_Sales_Order_Customer') !== ''),
              Options: _ctx.Customers,
              Selectors: [['Name'], ['Serial']],
              Res: 'D_Sales_Order_Customer'
            }, null, 8, ["Name", "CookiesInvalidInput", "ErrorData", "Options"]),
            _createVNode(_component_CookiesIcon, {
              class: "SQR2em V-Auto Pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.NewCustomer())),
              Tooltip: 'New',
              ID: 'Add'
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_CookiesDropInputObject, {
              Name: _ctx.Translate('Item'),
              CookiesInvalidInput: !(_ctx.MEMRead('D_Sales_Order_ItemName') && _ctx.MEMRead('D_Sales_Order_ItemName') !== ''),
              ErrorData: _ctx.ErrorsVisibilty && !(_ctx.MEMRead('D_Sales_Order_ItemName') && _ctx.MEMRead('D_Sales_Order_ItemName') !== ''),
              Options: _ctx.Items,
              Selectors: ['Name'],
              Res: 'D_Sales_Order_ItemName'
            }, null, 8, ["Name", "CookiesInvalidInput", "ErrorData", "Options"]),
            _createVNode(_component_CookiesIcon, {
              class: "SQR2em V-Auto Pointer",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.EditCategories('SalesItems', 'Items'))),
              Tooltip: 'New',
              ID: 'Add'
            })
          ]),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.$store.state.CookiesMemory.D_Sales_Order_CustomDate) = $event)),
              type: "date",
              class: "CookiesInput"
            }, null, 512), [
              [_vModelText, _ctx.$store.state.CookiesMemory.D_Sales_Order_CustomDate]
            ])
          ]),
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_CookiesNumberInput, {
              PreserveMemory: false,
              Name: _ctx.Translate('Quantity'),
              Default: 1,
              Min: 0,
              Res: 'D_Sales_Order_Quantity'
            }, null, 8, ["Name"]),
            _createVNode(_component_CookiesNumberInput, {
              MinWidth: '2em',
              PreserveMemory: false,
              Name: _ctx.Translate('Price'),
              Default: 1,
              Min: 0,
              Unit: _ctx.PriceUnit,
              Res: 'D_Sales_Order_Price'
            }, null, 8, ["Name", "Unit"])
          ]),
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_CookiesNumberInput, {
              MinWidth: '2em',
              style: {"margin":"unset"},
              PreserveMemory: false,
              Name: _ctx.Translate('Added Cost'),
              Default: 0,
              Min: 0,
              Unit: _ctx.PriceUnit,
              Res: 'D_Sales_Order_AddedCost'
            }, null, 8, ["Name", "Unit"])
          ]),
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_CookiesNumberInput, {
              style: {"margin":"unset"},
              PreserveMemory: false,
              Name: _ctx.Translate('Discount'),
              Default: 0,
              Max: 0,
              Unit: _ctx.PriceUnit,
              Res: 'D_Sales_Order_Discount'
            }, null, 8, ["Name", "Unit"])
          ]),
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", null, _toDisplayString(_ctx.Translate('Total')) + ": ", 1),
            _createElementVNode("span", _hoisted_16, _toDisplayString((_ctx.MEMRead('D_Sales_Order_Quantity') * _ctx.MEMRead('D_Sales_Order_Price')) + _ctx.MEMRead('D_Sales_Order_AddedCost') + _ctx.MEMRead('D_Sales_Order_Discount')) + " " + _toDisplayString(_ctx.PriceUnit), 1)
          ]),
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_CookiesNormalInput, {
              MinWidth: '3em',
              Placeholder: _ctx.Translate('Location'),
              Res: 'D_Sales_Order_Location'
            }, null, 8, ["Placeholder"])
          ]),
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_CookiesDescriptionBox, {
              Placeholder: _ctx.Translate('Notes'),
              Res: 'D_Sales_Order_Description'
            }, null, 8, ["Placeholder"])
          ])
        ])
      ])
    ], 8, _hoisted_1),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("button", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.go(-1))),
          style: {"background":"var(--colorr1)"},
          class: "F-Bold CookiesButton DialogFooterButton"
        }, _toDisplayString(_ctx.Translate('Cancel')), 1),
        _createElementVNode("button", {
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.SaveData && _ctx.SaveData(...args))),
          style: _normalizeStyle('background: ' + _ctx.Theme.UserColors.main),
          class: "F-Bold CookiesButton DialogFooterButton"
        }, _toDisplayString(_ctx.Translate('Save')), 5)
      ])
    ])
  ], 64))
}